import { useNavigate } from "react-router-dom";
import React, { useState, MouseEvent } from "react";
import ConfettiPage from "../ConfettiPage/ConfettiPage.component";
import envelope from "../../assets/icons/envelope.png";
import {
  ModalWrapper,
  ModalContent,
  ButtonsContainer,
  TextFieldContainer,
  CenteredImg,
  JoinwaitListHeader,
  AccountInfo,
} from "./JoinWaitlist.styles";
import TextFields from "../TextField/text-field.component";
import { colors } from "../../theme/color";
import Buttons from "../Button/button.component";
import { emailRegex } from "../../utils/EmailValidation";
import { useMutation } from "@apollo/client";
import { joinWaitlist } from "../../graphql/mutations/joinWaitlist";
import { environment } from "../../env";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";

type JoinWaitListProps = {
  showCongrats?: boolean;
  handleClick?: (event: MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
  handleCloseJoinWaitList?: (
    event: MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => void;
  closeModal?: () => void;
};

export const JoinWailist: React.FC<JoinWaitListProps> = (props) => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const [showConfetti, setShowConfetti] = useState(false);
  const [data, setData] = useState({
    email: "",
  });
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [joinWaitlistAction, { loading, error, data: saved }] =
    useMutation(joinWaitlist);

  const handleNameChange = (key: string, value: string) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));

    setIsValidEmail(emailRegex.test(value));
  };

  const isFormValid = () => {
    return data.email !== "" && isValidEmail;
  };

  const handleClickSubmit = async (e?: any) => {
    if (data.email) {
      try {
        const response = await joinWaitlistAction({
          variables: {
            sendNotificationTemplateId: environment.joinWaitlistTempId,
            sendNotificationEmails: [data.email],
          },
        });
        console.log(
          "<<<<<<<<<<<< Notification Response >>>>>>>>>>>>>>",
          response
        );
      } catch (error) {
        console.error("Error sending notification:", error);
      }
    }
  };

  React.useEffect(() => {
    if (!loading && saved) {
      props?.handleClick?.({} as any);
    }
  }, [saved, loading]);

  return (
    <ModalWrapper onClick={props.closeModal}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CenteredImg src="/assets/icons/envelope.png" alt="envelope" />
        <JoinwaitListHeader>
          {t("Join Waitlist", { lng: currentLocale })}
        </JoinwaitListHeader>
        <AccountInfo>Enter your email address to join waitlist</AccountInfo>
        {loading && <p>Processing...</p>}
        <TextFieldContainer>
          <TextFields
            id="email"
            type="email"
            placeholder="domain@company.com"
            value={data.email}
            onChange={(value: string) => handleNameChange("email", value)}
          />
        </TextFieldContainer>
        <ButtonsContainer>
          <Buttons
            handleClick={handleClickSubmit}
            label="Submit"
            width="98%"
            color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
            cursor="pointer"
            border="30px"
            height="48px"
            disabled={loading || !isFormValid()}
          />
        </ButtonsContainer>
      </ModalContent>
      {props.showCongrats && <ConfettiPage handleCloseCofetti={() => {}} />}
    </ModalWrapper>
  );
};

export default JoinWailist;
